import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone, Send } from "lucide-react";
import { toast } from "sonner";

export function AnnounceBuyerFinder() {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const load = () => api.get("/discovery/announce/preview").then((r) => setP(r.data)).catch(() => setP({}));
  useEffect(() => { load(); }, []);
  useEffect(() => { if (!p?.sending) return; const t = setInterval(load, 5000); return () => clearInterval(t); }, [p?.sending]);

  const send = async (test_only) => {
    setBusy(true);
    try {
      const { data } = await api.post("/discovery/announce", { test_only });
      toast.success(test_only ? `Test email sent to ${data.test_sent_to}` : `Sending to ${p.sellers} sellers in the background`);
      setConfirm(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not send"); } finally { setBusy(false); }
  };
  if (!p) return null;
  return (
    <div className="mt-5 rounded-lg border border-[#27272A] bg-[#0A0A0A] p-4 flex flex-wrap items-center gap-3" data-testid="announce-box">
      <Megaphone className="h-4 w-4 text-[#FF9F0A]" />
      <div className="text-sm">
        <div className="font-bold text-white">Announce Buyer Finder to every seller</div>
        <div className="text-xs text-neutral-500">"Your products now find their own buyers — worldwide" with a one-tap <span className="font-mono">Run my first scan</span> link · <span className="text-neutral-300" data-testid="announce-count">{p.sellers} sellers</span>
          {p.last_sent_at && <> · last sent {new Date(p.last_sent_at).toLocaleString()} to {p.last_count}</>}</div>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <button onClick={() => send(true)} disabled={busy} data-testid="announce-test-btn" className="h-9 px-4 rounded-full border border-[#27272A] text-xs font-bold text-white hover:border-neutral-500 disabled:opacity-50">Send me a test</button>
        {confirm ? (
          <button onClick={() => send(false)} disabled={busy || p.sending} data-testid="announce-confirm-btn" className="h-9 px-4 inline-flex items-center gap-2 rounded-full bg-[#FF3B30] text-white text-xs font-bold hover:bg-[#e0342a] disabled:opacity-50"><Send className="h-3.5 w-3.5" /> Yes, email all {p.sellers} sellers</button>
        ) : (
          <button onClick={() => setConfirm(true)} disabled={busy || p.sending} data-testid="announce-send-btn" className="h-9 px-4 inline-flex items-center gap-2 rounded-full bg-white text-black text-xs font-bold hover:bg-neutral-200 disabled:opacity-50"><Send className="h-3.5 w-3.5" /> {p.sending ? "Sending…" : "Send to all sellers"}</button>
        )}
      </div>
    </div>
  );
}
